import { getRefLanguages } from "../../../components/services/httpService";

export async function fetchRefLanguages() {
    const res = await getRefLanguages();
    if ( !res.ok ) {
        throw new Error( `Failed to fetch reference: languages: ${ res.status }` );
    }
    return await res.json();
}

